import { SvgIconProps } from "@mui/material";
import { SquareOutlined } from "@mui/icons-material";

export const CategoryIcon = (props: SvgIconProps) => {
  return <SquareOutlined {...props} fontSize="small" sx={squareIconStyles} />;
};

const squareIconStyles = { transform: "rotate(135deg)", height: 18, width: 18 };
